import { alpha, StyleRules } from '@material-ui/core/styles';
import { ToggleButtonClassKey } from '@material-ui/lab/ToggleButton';
import { core as theme } from '../styles/core';

export const MuiToggleButton: Partial<StyleRules<ToggleButtonClassKey>> = {
  root: {
    borderColor: theme.palette.grey.A400,
    color: theme.palette.grey[600],
    padding: '5px 15px',
    '&:hover': {
      backgroundColor: alpha(theme.palette.primary.light, 0.2),
      color: theme.palette.primary.main,
    },
    '&$selected': {
      backgroundColor: theme.palette.primary.main,
      borderColor: theme.palette.primary.main,
      color: theme.palette.grey[50],
      '&:hover': {
        backgroundColor: alpha(theme.palette.primary.main, 0.95),
        color: theme.palette.grey[50],
      },
    },
  },
};
